export default __webpack_public_path__ + "static/media/Ring of Corruption.f80dd2ae.jpg";